import { Component, OnInit, Output, EventEmitter, Input, Renderer2, ViewChild } from '@angular/core';
import { TimePickerDropDownComponent } from '../time-picker-drop-down/time-picker-drop-down.component';

@Component({
  selector: 'signals-time-selector',
  templateUrl: './time-picker-value.component.html',
  styleUrls: ['./time-picker-value.component.scss']
})
export class TimePickerValueComponent implements OnInit {
  @ViewChild('timePickerSelector', { read: TimePickerDropDownComponent })
  private timePickerSelector;
  @Output()
  onTimeChanged: EventEmitter<{ min: string; hr: string }> = new EventEmitter<{ min: string; hr: string }>();

  constructor(private readonly renderer: Renderer2) {}
  public value: number;
  public showDrp: boolean = false;
  private globalClickHandler;
  @Input()
  public selectedTime: { min: string; hr: string } = { min: '00', hr: '00' };
  public selectedTimeRef: { min: string; hr: string } = { min: '00', hr: '00' };
  @Input()
  timepickerID: string;

  ngOnInit() {
    this.initiateClickEventHandler();
  }

  public timeChanged() {
    this.onTimeChanged.emit(this.selectedTime);
  }

  public clearDateTime() {
    this.selectedTime = { hr: '00', min: '00' };
  }

  public toggleDrpDown() {
    this.showDrp = !this.showDrp;
    if (!this.showDrp) {
      this.checkAndEmit();
      return;
    }
    Object.assign(this.selectedTimeRef, this.selectedTime);
  }

  private checkAndEmit() {
    if (this.selectedTimeRef.hr !== this.selectedTime.hr || this.selectedTimeRef.min !== this.selectedTime.min) {
      this.onTimeChanged.emit(this.selectedTime);
    }
  }

  // We need to register event which could close the detail box if clicked outside of this hotspot box
  private initiateClickEventHandler() {
    if (!this.globalClickHandler) {
      this.globalClickHandler = this.renderer.listen(document, 'click', (event) => {
        if (!event.target.closest(`.time-picker-${this.timepickerID}`)) {
          if (this.showDrp) {
            this.checkAndEmit();
          }
          this.showDrp = false;
          return;
        }
      });
    }
  }
}
